import { TicketStatusTypes, TicketUrgencyTypes } from '../../domain/custom.ticket.item';

export class AddCustomTicketRequest {

    AdminID: number;
    MemberID: number;
    IsInternal: boolean;
    DueDate: Date;
    CreatedByAdmin: boolean;
    FromEmail: string;
    Status: TicketStatusTypes;
    Urgency: TicketUrgencyTypes;
    Body: string;
    IsHTMLBody: boolean;
    SendEmail: boolean;
    Subject: string;
    NotificationEmail: string;

}
